module.exports = __webpack_public_path__ + "img/banner-bel-fra.5cc6dce4.jpg";